import { css } from 'styled-components';

import Container from 'quarks/Container';
import type { BasicProps } from 'quarks/interpolations/basic';

import type { IComponentRichTableRecord } from 'graphql/types';
import type { FC } from 'react';

interface RichTableProps extends BasicProps, IComponentRichTableRecord {
  richTable?: IComponentRichTableRecord['richTable'];
}

const ComponentRichTable: FC<RichTableProps> = ({ richTable }: RichTableProps) => (
  <Container
    dangerouslySetInnerHTML={{ __html: richTable || '' }}
    maxWidth="1000px"
    marginX="auto"
    overflowX="auto"
    css={css`
      a:hover {
        text-decoration: none !important;
      }
      span {
        text-decoration: none !important;
      }
    `}
  ></Container>
);

export default ComponentRichTable;
